module.exports = __webpack_public_path__ + "img/refresh-adm.192f2826.svg";